/** localStorage key for ERP embed chrome-hide session (TROC-317). */
export const EMBEDDED_MODE_STORAGE_KEY = 'raptor.embedded';
